import Analytics from '@opencare/analytics';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation as useUrlLocation } from 'react-router-dom';

import { requestUserAndPatient } from 'connect/actions';
import { selectDataLoadingUser, selectDataUserAuthenticated } from 'connect/selectors';

import GoogleOneTapService from './GoogleOneTapService';

const analytics = new Analytics();

export const useGoogleOneTap = (): void => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(selectDataUserAuthenticated);
  const isLoadingUser = useSelector(selectDataLoadingUser);
  const urlLocation = useUrlLocation();

  const isPathAllowed = useMemo(() => {
    // Only show Google One Tap on specific allowed paths
    const googleOneTapAllowedPaths = [
      '/results',
    ];

    return googleOneTapAllowedPaths.some((path) => urlLocation.pathname.startsWith(path));
  }, [urlLocation.pathname]);

  useEffect(() => {
    if (!isPathAllowed || isAuthenticated || isLoadingUser) {
      return;
    }

    // Set up callback to update Redux store when authentication succeeds
    GoogleOneTapService.setAuthenticationSuccessCallback((isNewUser) => {
      dispatch(requestUserAndPatient());

      if (isNewUser) {
        analytics.trackSignUp({
          pageType: analytics.pageTypes.FUNNEL,
          pageName: urlLocation.pathname,
          name: 'google-one-tap',
        });
      }
    });

    GoogleOneTapService.initialize();
  }, [dispatch, isAuthenticated, isLoadingUser, isPathAllowed, urlLocation.pathname]);
};
